import './styles.scss'
import { IconMessage } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'
import { Text } from '@fragments'
import { useChat } from '@contexts/ChatContext'
import { useSidebar } from 'Screen/Sidebar/SidebarContext'

function getInitials(name = '') {
    const parts = name.trim().split(/\s+/)
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase()
    return (parts[0][0] + (parts[parts.length - 1]?.[0] || '')).toUpperCase()
}

export default function ChatFloatingButton({ inline = false }) {
    const { t } = useTranslation('chat')
    const { toggle, chats, totalUnread, open } = useChat()
    const { isMobile } = useSidebar()
    const firstThree = chats.slice(0, 3)

    if (open) return null

    // Render in inline mode only inside the sidebar (mobile/tablet);
    // render in floating mode only on desktop.
    if (isMobile && !inline) return null
    if (!isMobile && inline) return null

    return (
        <button
            type="button"
            className={`cfb${inline ? ' cfb--inline' : ''}`}
            onClick={toggle}
            aria-label={t('floatingButton.open')}
            aria-controls="chat-screen"
            aria-expanded={open}
        >
            {firstThree.length > 0 && (
                <div className="cfb__avatars">
                    {firstThree.map((chat, i) => (
                        <div
                            key={chat.id || i}
                            className="cfb__avatar"
                        >
                            {chat.avatar
                                ? <img src={chat.avatar} alt={chat.username} />
                                : <Text.caption>{getInitials(chat.username)}</Text.caption>
                            }
                        </div>
                    ))}
                </div>
            )}

            <Text.h4 weight={400} className="cfb__label" id="cfb-label">{t('floatingButton.label')}</Text.h4>

            <div className="cfb__icon-wrap">
                <IconMessage size={22} strokeWidth={1.6} />
                {totalUnread > 0 && (
                    <span className="cfb__badge">+{totalUnread > 99 ? '99' : totalUnread}</span>
                )}
            </div>
        </button>
    )
}
